import React from 'react';
import type { LayoutProps } from './types';
import { SPACING_CLASSES, GRID_COLS } from './types';
import { ImageItem } from './ImageItem';

export const GridLayout: React.FC<LayoutProps> = ({
  filteredItems,
  colors,
  data,
  imageRefs,
  onImageClick,
}) => {
  const gridColsClass = GRID_COLS[data.columns as keyof typeof GRID_COLS] || GRID_COLS[3];
  const spacingClass = SPACING_CLASSES[data.spacing] || SPACING_CLASSES.normal;

  return (
    <div className={`grid ${gridColsClass} ${spacingClass}`}>
      {filteredItems.map((item, index) => (
        <ImageItem
          key={item.id}
          item={item}
          index={index}
          lightboxEnabled={data.lightbox}
          lazyLoading={data.lazyLoading}
          captionPosition={data.captionPosition}
          aspectRatio={data.aspectRatio}
          captionColor={colors.captionColor}
          imageRefs={imageRefs}
          onImageClick={onImageClick}
        />
      ))}
    </div>
  );
};
